module.exports = __webpack_public_path__ + "static/media/rainbow_dragon.7942d69a.webp";